<template>
  <div class="py-4 container-fluid">
    <!-- <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'export-excel/karyawan?id_karyawan='+search.id_karyawan+'&nama='+search.nama+'&nik='+search.nik+'&jabatan='+search.jabatan+'&unit='+search.unit+'&status='+search.status+''" target="_BLANK"><i class="fa fa-download fa-sm"></i> Export</a> -->
    <!-- <argon-button color="info" size="sm" class="mb-3" variant="gradient" style="margin-right: 10px;"><i class="fa fa-download fa-sm"></i> Export</argon-button> -->
    <!-- <argon-button color="warning" size="sm" class="mb-3" variant="gradient" @click="modalImport()"><i class="fa fa-upload fa-sm"></i> Import</argon-button> -->
    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-12 text-center">
                <div class="card-header pb-0">
                  <h6>MASTER LIST DETAILS</h6><hr>
                </div>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="container">
                <div class="row">
                  <div class="col-lg-6 col-sm-12">
                    <p style="margin-top: 10px; font-size: 13px; font-weight: bold;">PROJECT CODE <span style="margin-left: 18px; margin-right: 10px;">:</span> 
                      <span class="badge bg-gradient-primary">{{ dataProject.project_code }}</span>
                    </p>
                    <p style="margin-top: -7px; font-size: 13px; font-weight: bold;">PROJECT NAME <span style="margin-left: 15px; margin-right: 10px;">:</span> {{ dataProject.project_name }}</p>
                    <p style="margin-top: -7px; font-size: 13px; font-weight: bold;">DESCRIPTION <span style="margin-left: 25px; margin-right: 10px;">:</span> {{ dataProject.description }}</p>
                  </div>
                  <div class="col-lg-6 col-sm-12">
                    <p style="margin-top: -7px; font-size: 13px; font-weight: bold;">CUSTOMER <span style="margin-left: 20px; margin-right: 10px;">:</span> {{ dataProject.customer }}</p>
                    <p style="margin-top: -7px; font-size: 13px; font-weight: bold;">WEIGHT <span style="margin-left: 40px; margin-right: 10px;">:</span> {{ dataProject.weight }}</p>
                    <p style="margin-top: -7px; font-size: 13px; font-weight: bold;">WEIGHT <span style="margin-left: 40px; margin-right: 10px;">:</span> {{ dataProject.unit }}</p>
                    <p style="margin-top: -7px; font-size: 13px; font-weight: bold;">DUE DATE <span style="margin-left: 30px; margin-right: 10px;">:</span> {{ moment(dataProject.due_date).locale('id').format('LL') }}</p>
                  </div>
                </div>
                <h5>PROGRESS ALL : <span class="text-warning"> {{ dataProject.progress }} %</span></h5>
              </div><hr>

                <div>
                  <div class="container">
                  </div>
                  <div class="container-fluid">
                    <!-- <nav class="mt-4">
                      <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#Sparepart" type="button" role="tab" aria-controls="nav-home" aria-selected="true"><i class="fa fa-tags" style="margin-right: 10px;"></i> Sparepart</button>
                      </div>
                    </nav> -->
                    <!-- <hr style="height: 5px;"> -->

                    <div class="tab-content mt-0" id="nav-tabContent">

                      <!-- Sparepart -->
                      <div class="tab-pane fade show active" id="Sparepart" role="tabpanel" aria-labelledby="nav-home-tab">
                        <div class="row mt-n3">
                          <div class="col-4">
                            <div class="card-header pb-0">
                              <h6><i class="fa fa-tags" style="margin-right: 10px;"></i>Master List</h6>
                            </div>
                          </div>
                          <div class="col-4">
                            <input type="text" class="form-control mt-4" placeholder="Search Item No ..." @keyup="get()" v-model="searchMasterList.item_no">
                          </div>
                          <div class="col-4 float-right">
                            <argon-button
                              style="margin-right: 10px; margin-left: 60px;"
                              class="mt-4"
                              variant="gradient"
                              color="secondary"
                              size="sm"
                              @click="filterSparepart()"
                            ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                            <argon-button
                              class="mt-4"
                              variant="gradient"
                              color="success"
                              size="sm"
                              @click="createSparepart()"
                            ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
                          </div>
                        </div>
                        <div class="table-responsive table-bordered scroll mt-3">
                          <table class="table table-striped table-hover align-items-center mb-0">
                            <thead>
                              <tr style="background-color: #6495ED; color: white;">
                                <th rowspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">No</th>
                                <th rowspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Description</th>
                                <th rowspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Drawing No.</th>
                                <th rowspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Assy No.</th>
                                <th rowspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Item No.</th>
                                <th rowspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Qty</th>
                                <th rowspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Material</th>
                                <th rowspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Grade</th>
                                <th rowspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Length (mm)</th>
                                <th rowspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Unit Assembly Weight (Kg)</th>
                                <th rowspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Total Weight (Kg)</th>
                                <th colspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">CUT & DRILL <br> ( 25 % )</th>
                                <th colspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">FIT UP / ASSEMBLY  <br> ( 35 % )</th>
                                <th colspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">WELDING  <br> ( 35 % )</th>
                                <th colspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">CLEANING  <br> ( 5 % )</th>
                                <th colspan="2" class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">FAB PROGRESS</th>
                                <th rowspan="2" class="text-center text-uppercase text-white text-xxs font-weight-bolder">Action</th>
                              </tr>
                              <tr style="background-color: #6495ED; color: white;">
                                <th class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Qty</th>
                                <th class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">%</th>
                                <th class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Qty</th>
                                <th class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">%</th>
                                <th class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Qty</th>
                                <th class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">%</th>
                                <th class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">Qty</th>
                                <th class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">%</th>
                                <th class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">%</th>
                                <th class="text-center text-uppercase text-white text-secondary text-xxs font-weight-bolder">WEIGHT</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in table.data" :key="i" @click="setBg(i)" :style="(backgroundRed == i) ? 'background-color: #7FFF00; cursor: pointer;' : 'cursor: pointer;' ">
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ i + 1 }}</span>
                                </td>
                               <!--  <td class="align-middle text-center text-sm">
                                    :src="storageUrl+'/image_sparepart/'+row.image"
                                    class="avatar avatar-lg me-1"
                                  />
                                </td> -->
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ row.description }}</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                   <span class="text-secondary text-xs font-weight-bold">
                                    <a :href="storageUrl+'drawing_master_list/'+row.drawing_no+'.pdf'" target="_BLANK" style="color: blue; size: 5px;">{{ row.drawing_no }}</a>
                                  </span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ row.assy_no }}</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ row.item_no }}</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ row.qty }}</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ row.material }}</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ row.grade }}</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ row.length }}</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ convertRp(row.weight) }}</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ convertRp(row.weight) }}</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">
                                    <input type="number" class="form-control input-sm" placeholder="Qty Cut Dril"  @change="editItem" :value="row.cut_dril_qty" :id="row.id" :max="row.qty">
                                  </span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ ((row.cut_dril_qty/row.qty) * 25 ) }} %</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">
                                    <input type="number" class="form-control input-sm" placeholder="Qty Fit Up"  @change="editItem" :value="row.fit_up_qty" :id="row.id" :max="row.qty">
                                  </span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ ((row.fit_up_qty/row.qty) * 35) }} %</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">
                                    <input type="number" class="form-control input-sm" placeholder="Qty Welding"  @change="editItem" :value="row.welding_qty" :id="row.id" :max="row.qty">
                                  </span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ ((row.welding_qty/row.qty) * 35) }} %</span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">
                                    <input type="number" class="form-control input-sm" placeholder="Qty Cleaning"  @change="editItem" :value="row.cleaning_qty" :id="row.id" :max="row.qty">
                                  </span>
                                </td>
                                <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ ((row.cleaning_qty/row.qty) * 5) }} %</span>
                                </td>
                                 <td class="align-middle text-center text-sm">
                                  <span class="text-danger text-xs font-weight-bold">
                                    <strong>{{ row.fab_progress }} %</strong>
                                  </span>
                                </td>
                                 <td class="align-middle text-center text-sm">
                                  <span class="text-secondary text-xs font-weight-bold">{{ (row.weight * row.fab_progress) }}</span>
                                </td>
                                <td class="align-middle text-center">
                                  <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="editSparepart(row.id)" title="Edit"></i>
                                  <i class="fas fa-trash fa-sm" aria-hidden="true" title="Hapus" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id)"></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

              <!-- </div> -->
            </div>
            <div class="card-footer">
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL ADD DATA SPAREPART ======= -->
  <div class="container">
    <vue-final-modal v-model="formSparepart.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formSparepart.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formSparepart.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Description <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Description" v-model="masterListData.description">
        <label for="example-text-input" class="form-control-label mt-3">Drawing No. <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Drawing No" v-model="masterListData.drawing_no">
        <label for="example-text-input" class="form-control-label mt-3">Assy No. <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Assy No." v-model="masterListData.assy_no">
        <label for="example-text-input" class="form-control-label mt-3">Item No. <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Item No." v-model="masterListData.item_no">
        <label for="example-text-input" class="form-control-label mt-3">Qty <span style="color: red;">*</span></label>
        <input type="number" class="form-control" placeholder="Qty" v-model="masterListData.qty">
        <label for="example-text-input" class="form-control-label mt-3">Material <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Material" v-model="masterListData.material">
        <label for="example-text-input" class="form-control-label mt-3">Grade <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Grade" v-model="masterListData.grade">
        <label for="example-text-input" class="form-control-label mt-3">Length <span style="color: red;">*</span></label>
        <input type="number" class="form-control" placeholder="Length" v-model="masterListData.length">
        <label for="example-text-input" class="form-control-label mt-3">Weight <span style="color: red;">*</span></label>
        <input type="number" class="form-control" placeholder="Weight" v-model="masterListData.weight">
        <label for="example-text-input" class="form-control-label mt-3">Cut & Dril Qty </label>
        <input type="number" class="form-control" placeholder="Cut & Dril Qty" v-model="masterListData.cut_dril_qty">
        <label for="example-text-input" class="form-control-label mt-3">Fit Up Qty </label>
        <input type="number" class="form-control" placeholder="Fit Up Qty" v-model="masterListData.fit_up_qty">
        <label for="example-text-input" class="form-control-label mt-3">Welding Qty </label>
        <input type="number" class="form-control" placeholder="Welding Qty" v-model="masterListData.welding_qty">
        <label for="example-text-input" class="form-control-label mt-3">Cleaning Qty </label>
        <input type="number" class="form-control" placeholder="Cleaning Qty" v-model="masterListData.cleaning_qty">
        <label for="example-text-input" class="form-control-label mt-3">Attachment Drawing <span style="color: red;">*</span></label>
        <input type="file" ref="fileupload" class="form-control" placeholder="Attachment Drawing" @change="filesChange">
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formSparepart.show = true">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveSparepart()">Save</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL FILTER SPAREPART ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilterSpare.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilterSpare.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilterSpare.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Sparepart Name</label>
        <input type="text" class="form-control" placeholder="Sparepart Name" v-model="searchMasterList.component_name" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Specification</label>
        <input type="text" class="form-control" placeholder="Specification" v-model="searchMasterList.specification" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Storage Location</label>
        <input type="text" class="form-control" placeholder="Storage Location" v-model="searchMasterList.location" v-on:keyup.enter="get()">
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="searchMasterList = {}">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="get()">Filter</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
// import ArgonPagination from "@/components/ArgonPagination.vue";
// import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import masterList from '@/services/master_list/masterList.service';

export default {
  name: "tables",
  components: {
    ArgonButton,
    VueFinalModal,
    // ArgonPagination,
    // ArgonPaginationItem,
  },
  data() {
    return {
      moment:moment,
      table: {
        data: []
      },
      formSparepart: {
        add: true,
        title: "Add Sparepart",
        show: false
      },
      formFilterSpare: {
        add: true,
        title: "Filter",
        show: false
      },
      onLoading: false,
      tabelError: {
        data: []
      },
      storageUrl : config.storageUrl,
      dataProject: {},
      masterListData: {},
      searchMasterList: {
        description: '',
        drawing_no: '',
        assy_no: '',
        item_no: '',
        material: '',
        grade: '',
      },
      apiUrl :config.apiUrl,
      backgroundRed: null,

    };
  },
  mounted(){
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
  },
  methods: {
    get(param){
      let context = this;               
      Api(context, masterList.getDetail({project_code: context.$route.params.project_code, description: context.searchMasterList.description, drawing_no: context.searchMasterList.drawing_no, assy_no: context.searchMasterList.assy_no, item_no: context.searchMasterList.item_no, material: context.searchMasterList.material, grade: context.searchMasterList.grade })).onSuccess(function(response) {    
          context.table.data = response.data.data.data;
          context.dataProject = response.data.data.dataProject;

          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
      })
      .call()
    },
    filterSparepart() {
      this.formFilterSpare.add   = true;
      this.formFilterSpare.show  = true;
      this.formFilterSpare.title = "Filter Sparepart";
      this.onLoading = false;
    },
    createSparepart() {
      this.formSparepart.add   = true;
      this.formSparepart.show  = true;
      this.formSparepart.title = "Add Sparepart";
      this.masterListData   = {};
    },
    editSparepart(id) {
      let context = this;               
      Api(context, masterList.show(id)).onSuccess(function(response) {
          context.masterListData       = response.data.data;
          context.formSparepart.show  = true;
          context.formSparepart.title = 'Edit Data';   
      })
      .call()        
    },
    filesChange(e) {
        this.masterListData.image = e.target.files[0];
    },
    saveSparepart(){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      if (context.$route.params.project_code != undefined && context.masterListData.description != undefined && context.masterListData.drawing_no != undefined && context.masterListData.assy_no != undefined && context.masterListData.item_no != undefined && context.masterListData.qty != undefined && context.masterListData.material != undefined && context.masterListData.grade != undefined && context.masterListData.length != undefined && context.masterListData.weight != undefined) {
        formData.append('ml_no', context.$route.params.project_code);
        formData.append('description', context.masterListData.description);
        formData.append('drawing_no', context.masterListData.drawing_no);
        formData.append('assy_no', context.masterListData.assy_no);
        formData.append('item_no', context.masterListData.item_no);
        formData.append('qty', context.masterListData.qty);
        formData.append('material', context.masterListData.material);
        formData.append('grade', context.masterListData.grade);
        formData.append('length', context.masterListData.length);
        formData.append('weight', context.masterListData.weight);
        formData.append('cut_dril_qty', (this.masterListData.cut_dril_qty == undefined) ? '-' : this.masterListData.cut_dril_qty);
        formData.append('fit_up_qty', (this.masterListData.fit_up_qty == undefined) ? '-' : this.masterListData.fit_up_qty);
        formData.append('welding_qty', (this.masterListData.welding_qty == undefined) ? '-' : this.masterListData.welding_qty);
        formData.append('cleaning_qty', (this.masterListData.cleaning_qty == undefined) ? '-' : this.masterListData.cleaning_qty);
      }else{
        return alert('The Red Star Field is Mandatory')
      }

      if (context.formSparepart.title == 'Add Sparepart') {
          api = Api(context, masterList.create(formData));
      } else {
          api = Api(context, masterList.update(this.masterListData.id, formData));
      }
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.get();
        context.formSparepart.show = false;
        context.notify((context.form === 'Add Sparepart') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.form != 'Add Sparepart') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
      })
      .call();
    },
    remove(id) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context = this;

        Api(context, masterList.delete(id)).onSuccess(function(response) {
            context.get();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    editItem(param) {
      let id          = param.target.id
      let placeholder = param.target.placeholder

      let context = this;               
      Api(context, masterList.show(id)).onSuccess(function(response) {
          context.masterListData       = response.data.data;
          context.formSparepart.title = 'Edit Data';   

          if (placeholder == 'Qty Cut Dril') {
            context.masterListData.cut_dril_qty = param.target.value;
          }
          if (placeholder == 'Qty Fit Up') {
            context.masterListData.fit_up_qty = param.target.value;
          }
          if (placeholder == 'Qty Welding') {
            context.masterListData.welding_qty = param.target.value;
          }
          if (placeholder == 'Qty Cleaning') {
            context.masterListData.cleaning_qty = param.target.value;
          }
          context.saveSparepart() 
      })
      .call()       
    },

    
    setBg(id) {
      this.backgroundRed = id
    },
    convertRp(bilangan) {
      // if (bilangan) {
      //   var number_string = bilangan.toString(),
      //       sisa    = number_string.length % 3,
      //       rupiah  = number_string.substr(0, sisa),
      //       ribuan  = number_string.substr(sisa).match(/\d{3}/g);

      //   if(ribuan){
      //     var separator = sisa ? '.' : '';
      //     rupiah += separator + ribuan.join('.');
      //     return rupiah
      //   }else{
      //     return bilangan
      //   }
      // }

      var data =  Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR"
      }).format(bilangan);

      return data.substr(3)
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        }); // ToastOptions
      }
    },

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll { 
  overflow: auto; 
  height: 700px; 
}
.scroll-min { 
  overflow: auto; 
  height: 300px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
}
</style>
